import React from 'react';

import {type Ref as SectionRef} from '../../../state/views/panelBankSectionConfig/types';
import {type DrawerContentType} from '../WorkspaceDrawerContextProvider';
import {SectionSettingsContent} from './SectionSettingsContent';
import {SectionSettingsContextProvider} from './SectionSettingsContextProvider';

export const SectionSettings = ({
  displayedContentType,
  sectionRef,
}: {
  displayedContentType: DrawerContentType;
  sectionRef: SectionRef;
}) => {
  return (
    <SectionSettingsContextProvider sectionRef={sectionRef}>
      <SectionSettingsContent displayedContentType={displayedContentType} />
    </SectionSettingsContextProvider>
  );
};
